import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IOpportunityFollowUpTask } from "../../utils/types/models";

export default createEntityReducer<IOpportunityFollowUpTask>(Endpoint.OpportunityFollowUpTasks, Endpoint.OpportunityFollowUpTasksList);
